import { Route } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import BusinessConfigPage from '../pages/Business/BusinessConfigPage';
import DocumentSequences from '../pages/DocumentSequence/DocumentSequences';
import BranchConfigurationPage from '../pages/Branch/BranchConfigurationPage';
import SystemConfigPage from '../pages/Settings/systemConfig/SystemConfigPage';
import ProtectedRouteV2 from './ProtectedRouteV2';
import ReportsConfigPage from '../pages/Settings/reportsConfig/ReportsConfigPage';
import SystemOperationModePage from '../pages/Settings/systemOperationMode/SystemOperationModePage';
import EnabledDocumentTypesPage from '../pages/Hacienda/EnabledDocumentTypesPage';
import DteTestProgressAdminPage from '../pages/Hacienda/DteTestProgressAdminPage';
import CorrelativesAdminPage from '../pages/Settings/CorrelativesAdminPage';
import SystemPlanPage from '../pages/Settings/SystemPlanPage';
import UserPreferencesPage from '../pages/Settings/UserPreferencesPage';
import BackupSettingsPage from '../pages/Settings/BackupSettingsPage';
import ClientProfileModulesPage from '../pages/Client/ClientProfileModulesPage';
import CashResetPage from '../pages/Settings/CashResetPage';
import QuotationPdfDesignPage from '../pages/Settings/PdfDesigns/QuotationPdfDesignPage';

const settingsRoutes = (
  <Route element={<ProtectedRouteV2 />}>
    <Route
      path="/settings/system"
      element={
        <>
          <PageTitle title="Configuración del Sistema | POS System" />
          <SystemConfigPage />
        </>
      }
    />
    <Route
      path="/settings/system-plan"
      element={
        <>
          <PageTitle title="Plan del Sistema | POS System" />
          <SystemPlanPage />
        </>
      }
    />
    <Route
      path="/settings/preferences"
      element={
        <>
          <PageTitle title="Preferencias del Usuario | POS System" />
          <UserPreferencesPage />
        </>
      }
    />
    <Route
      path="/settings/backup"
      element={
        <>
          <PageTitle title="Respaldo del Sistema | POS System" />
          <BackupSettingsPage />
        </>
      }
    />
    <Route
      path="/settings/business"
      element={
        <>
          <PageTitle title="Configuración de Empresa | POS System" />
          <BusinessConfigPage />
        </>
      }
    />
    <Route
      path="/settings/document-sequences"
      element={
        <>
          <PageTitle title="Series Autorizadas | POS System" />
          <DocumentSequences />
        </>
      }
    />
    <Route
      path="/settings/branches"
      element={
        <>
          <PageTitle title="Configuración de Sucursales | POS System" />
          <BranchConfigurationPage />
        </>
      }
    />
    <Route
      path="/settings/reports-config"
      element={
        <>
          <PageTitle title="Configuración de Reportes | POS System" />
          <ReportsConfigPage />
        </>
      }
    />
    <Route
      path="/settings/system-operation-mode"
      element={
        <>
          <PageTitle title="Modo de Operación | POS System" />
          <SystemOperationModePage />
        </>
      }
    />

    <Route
      path="/settings/dte-enabled-documents"
      element={
        <>
          <PageTitle title="Documentos Habilitados | POS System" />
          <EnabledDocumentTypesPage />
        </>
      }
    />

    <Route
      path="/settings/dte-test-progress"
      element={
        <>
          <PageTitle title="Progreso de Pruebas DTE | POS System" />
          <DteTestProgressAdminPage />
        </>
      }
    />

    <Route
      path="/settings/correlatives-admin"
      element={
        <>
          <PageTitle title="Administración de Correlativos | POS System" />
          <CorrelativesAdminPage />
        </>
      }
    />

    {/* Configuración de Módulos (antes bajo Perfiles de Cliente). */}
    <Route
      path="/settings/modules"
      element={
        <>
          <PageTitle title="Configuración de Módulos | POS System" />
          <ClientProfileModulesPage />
        </>
      }
    />

    <Route
      path="/settings/cash-reset"
      element={
        <>
          <PageTitle title="Limpieza de Caja | POS System" />
          <CashResetPage />
        </>
      }
    />

    <Route
      path="/settings/pdf-designs/quotation"
      element={
        <>
          <PageTitle title="Diseño de Cotizaciones | POS System" />
          <QuotationPdfDesignPage />
        </>
      }
    />
  </Route>
);

export default settingsRoutes;
